import { render, staticRenderFns } from "./LeftTextBorderMany.vue?vue&type=template&id=661d4b85&scoped=true"
import script from "./LeftTextBorderMany.vue?vue&type=script&lang=js"
export * from "./LeftTextBorderMany.vue?vue&type=script&lang=js"
import style0 from "./LeftTextBorderMany.vue?vue&type=style&index=0&id=661d4b85&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "661d4b85",
  null
  
)

export default component.exports